import { useState } from "react";
import { scopeKey } from "@/lib/api";

export const ScopeToggle = () => {
  const [v, setV] = useState(() => localStorage.getItem(scopeKey()) || "all");
  const pick = (x) => {
    if (x === v) { return; }
    localStorage.setItem(scopeKey(), x);
    setV(x);
    window.location.reload();
  };
  const btn = (x, label) => (
    <button type="button" onClick={() => pick(x)} data-testid={`scope-toggle-${x}`}
      className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${v === x ? "bg-ink text-white" : "text-slate-600 hover:bg-slate-100"}`}>{label}</button>
  );
  return (
    <div className="hidden items-center gap-0.5 rounded-full border border-line bg-white p-0.5 sm:flex" title="Filtra dashboard ed elenchi" data-testid="scope-toggle">
      {btn("mine", "Le mie")}{btn("all", "Tutta l'azienda")}
    </div>
  );
};
